import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { UserSceneProps } from "../types";

/** Korak "Kontakt": email i telefoni korisnika, pa poziv na mobitel. */
const UserContactScene: React.FC<UserSceneProps> = ({ user }) => {
  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="flex items-center gap-3">
            <span className="flex items-center justify-center w-11 h-11 rounded-full bg-blue-100 text-sm font-bold text-blue-700 flex-shrink-0">
              {user.initials}
            </span>
            <div className="min-w-0">
              <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Kontakt</div>
              <div className="text-sm font-bold text-slate-800 truncate">{user.fullName}</div>
            </div>
          </div>

          <div className="mt-4 space-y-2">
            {[
              { label: "Email", value: user.email },
              { label: "Telefon", value: user.phone },
              { label: "Mobitel", value: user.mobile },
            ].map((row) => (
              <div key={row.label} className="rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]">
                <div className="text-[0.6rem] text-slate-400">{row.label}</div>
                <div className="font-semibold text-slate-800 truncate">{row.value}</div>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Poziv</div>
          <div className="mt-2 text-xs font-bold text-slate-800 truncate">{user.fullName}</div>
          <div className="text-[0.65rem] text-slate-400 truncate">{user.mobile}</div>
          <div className="mt-3 flex gap-2">
            <span className="flex-1 rounded-sm bg-emerald-500 py-1 text-center text-[0.6rem] font-semibold text-white">Nazovi</span>
            <span className="flex-1 rounded-sm bg-slate-100 py-1 text-center text-[0.6rem] font-semibold text-slate-600">Email</span>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Jedinstven email"
          subtitle="Provjerava se prije sljedećeg koraka"
          iconClassName="bg-emerald-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#047857" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M4 4h16v16H4zM4 6l8 7 8-7" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(UserContactScene);
